import { ListItemIcon, ListItemText, MenuItem } from '@mui/material';
import { SvgIconComponent } from '@mui/icons-material';

interface Props {
    onClick: () => void;
    title: string;
    isActive?: boolean;
    icon: SvgIconComponent;
}

export const UserMenuItem = ({ onClick, icon, title, isActive }: Props) => {
    const Icon = icon;

    return (
        <MenuItem onClick={onClick} selected={isActive}>
            <ListItemIcon>
                <Icon />
            </ListItemIcon>
            <ListItemText>{title}</ListItemText>
        </MenuItem>
    );
};
